import React from 'react';
import { motion } from 'framer-motion';
const quotes = ['No venís a cortarte el pelo. Venís a Rotterdam.', 'Toalla caliente, navaja precisa y cerveza fría.', 'Entrás a cortarte el pelo. Salís sintiéndote otro.', 'La barra Rotterdam no es un extra. Es la diferencia.'];
export function OneLiners() {
  return <section className="py-24 px-6 bg-rotterdam-dark overflow-hidden" data-id="element-144">
      <div className="max-w-4xl mx-auto" data-id="element-145">
        <div className="space-y-12" data-id="element-146">
          {quotes.map((quote, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -50 : 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.8,
          delay: index * 0.1
        }} className={`text-2xl md:text-4xl font-serif italic text-rotterdam-cream/80 ${index % 2 === 0 ? 'text-left' : 'text-right'}`} data-id="element-147">
              "{quote}"
            </motion.div>)}
        </div>
      </div>
    </section>;
}